import {UserType} from '../../../../service/user/user-type';

export function getCentrifugeReportMessagesName(user: UserType | null): string {
    return `comparison_reports:status#${user?.id}`;
}
